import services from 'services/services';
import _ from 'lodash';

// Import variables
import { AGREEMENTS_TYPES } from 'helpers/agreements';

// Import api
import {
	SUBSCRIBER_AGREEMENTS_API,
	SUBSCRIBER_ANONIMIZE_API,
	SUBSCRIBER_BLOCKING_API
} from 'helpers/api';

const { RODO } = AGREEMENTS_TYPES;

// API REQUESTS
export const postAgreements = async (agreementIds, isAccepted) => {
	const urlSlug = isAccepted ? 'accept' : 'decline';
	const url = `${SUBSCRIBER_AGREEMENTS_API}/${urlSlug}`;
	const payload = { agreement_version_ids: agreementIds };
	return services.post(url, payload);
};

export const postAllAgreements = async ({ acceptedIds, declinedIds }) => {
	return Promise.all([
		postAgreements(acceptedIds, true),
		postAgreements(declinedIds, false)
	]);
};

export const postAnonymize = async () => {
	return services.post(SUBSCRIBER_ANONIMIZE_API);
};

export const postSubscriberBlocking = async () => {
	return services.post(SUBSCRIBER_BLOCKING_API);
};

// PREPARE DATA
export const prepareUpdatedAgreementsList = ({
	agreements,
	userActiveAgreements
}) => {
	const updatedAgreementsList = agreements.map(
		({ id, obligatory, type, version: { description, id: version_id } }) => {
			const isAccepted = userActiveAgreements.some(
				({ agreement_version }) => agreement_version.id === version_id
			);
			// return simple data, for better readability
			// finally API accepts only array of version_ids
			return { id, type, description, version_id, isAccepted, obligatory };
		}
	);

	return updatedAgreementsList;
};

export const prepareAgreementsIds = ({ currentAgreementsList }) => {
	const acceptedIds = currentAgreementsList
		.filter(({ isAccepted }) => isAccepted)
		.map(({ version_id }) => version_id);

	const declinedIds = currentAgreementsList
		.filter(({ isAccepted }) => !isAccepted)
		.map(({ version_id }) => version_id);

	return { acceptedIds, declinedIds };
};

// CHECK DATA
export const checkObligatoryChange = ({
	currentAgreementsList,
	initialAgreementsList
}) => {
	const currentObligatory = currentAgreementsList.filter(
		({ obligatory }) => obligatory
	);
	const initialObligatory = initialAgreementsList.filter(
		({ obligatory }) => obligatory
	);

	const isSameObligatory = _.isEqual(currentObligatory, initialObligatory);
	return { isSameObligatory };
};

export const checkIsRodoActive = ({ currentAgreementsList }) => {
	const activeRodoAgreement = currentAgreementsList.filter(
		({ type, isAccepted }) => type === RODO && isAccepted
	);
	const isRodoActive = activeRodoAgreement.length;
	return { isRodoActive };
};
